const baseKey = '/v1/trader/topups/limits';

export const topupLimitsAPI = {
  baseKey,
  channels: `${baseKey}/channels`,
};